'use client';
import _extends from '@babel/runtime/helpers/extends';
import React__default, { useContext, useEffect } from 'react';
import Script from 'next/script';
import { CohesionContext, BricksContext } from './Provider.js';
import { cohesionReady, contextCreated, preampDecisionsReceived, monarchDone, preampError, tagularReady, fuseLeaseRecieved, fuseError, cohesionCatch } from '../../utils/cohesionEvents.js';
import { logError } from '../../utils/logging.js';
import { useCohesionTimeout } from './useCohesionTimeout.js';
import { debugLog } from '../../utils/debugLog.js';

const CohesionScript = props => {
  const {
    preampDecisions,
    setPreampDecisions,
    setFuseNumber,
    defaultFuseNumber,
    callMonarchWithPreamp
  } = useContext(CohesionContext);
  const {
    setMonarchResponse,
    setMonarchAutoCallResponse,
    setRenderedDecisions
  } = useContext(BricksContext);
  useCohesionTimeout(preampDecisions, setPreampDecisions);
  useEffect(() => {
    try {
      debugLog('Cohesion Script - Setting Cohesion event listeners');
      // Send a page action to new relic when cohesion is ready.
      window?.cohesion('ready', cohesionReady);
      window?.cohesion('context:created', contextCreated(setMonarchAutoCallResponse, setMonarchResponse, setPreampDecisions, setRenderedDecisions));

      // EventListner that will listen for preamp to be done loading
      window?.cohesion('preamp:decisionsReceived', preampDecisionsReceived(setPreampDecisions, setMonarchResponse, callMonarchWithPreamp));
      window?.cohesion('monarch:done', monarchDone(setMonarchAutoCallResponse));

      // Enable default components if preamp erros.
      window?.cohesion('preamp:error', preampError(setPreampDecisions));
      window?.cohesion('tagular:ready', tagularReady);
      window?.cohesion('fuse:leasesReceived', fuseLeaseRecieved(setFuseNumber));
      window?.cohesion('fuse:error', fuseError(setFuseNumber, defaultFuseNumber));
    } catch (error) {
      cohesionCatch(error);
    }
  }, []);
  const handleOnError = error => {
    console.error('Cohesion script - failed to load', error);
    logError(`cohesion:script: failed to load - ${error}`);
    debugLog('cohesion snippet failed to load', error);
    setRenderedDecisions(true);
  };
  return /*#__PURE__*/React__default.createElement(Script, _extends({
    strategy: "beforeInteractive",
    src: "/cohesion/cohesion-latest.min.js",
    onError: handleOnError
  }, props));
};

export { CohesionScript };
